/**
 * Labstep
 *
 * @module components/User/Form/ResetPassword
 * @desc ResetPassword form
 */

import { Button } from 'labstep-web/core/Button';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type React from 'react';
import {
  fieldUserSignupPassword,
  fieldUserSignupPasswordConfirmation,
} from '../fields';
import { printStatusError } from '../Signup';
import type { IUserFormResetPasswordProps } from './types';

export const UserFormResetPassword: React.FC<
  IUserFormResetPasswordProps
> = ({ resetPassword, status, token }) => (
  <div>
    <FormReusable
      onSubmit={(form) => resetPassword({ ...form, token })}
      fields={[
        fieldUserSignupPassword,
        fieldUserSignupPasswordConfirmation,
      ]}
      error={printStatusError(status)}
      submitButton={
        <Button fluid primary status={status}>
          Submit
        </Button>
      }
    />
  </div>
);
